import * as React from 'react';
import { useEffect, useState } from 'react';
import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { BarrioHero } from '../../components/barrio-show/BarrioHero';
import { BarrioStats } from '../../components/barrio-show/BarrioStats';
import { BarrioDelivery } from '../../components/barrio-show/BarrioDelivery';
import { BarrioNearby } from '../../components/barrio-show/BarrioNearby';
import { BarrioSEO } from '../../components/barrio-show/BarrioSEO';
import { WhyFresh } from '../../components/barrios-landing/WhyFresh';
import { TrustedDelivery } from '../../components/barrios-landing/TrustedDelivery';
import { BarriosProducts } from '../../components/barrios-landing/BarriosProducts';
import { FinalCTA } from '../../components/barrios-landing/FinalCTA';
import type { BarrioShowProps } from '../../types/barrios-landing';

const LazyBarrioMap = React.lazy(() => import('../../components/barrio-show/BarrioMap'));

export default function BarrioShow({ barrio, stats, dynamicPhrases, delivery, nearby, featuredProducts, appUrl, whatsappUrl, discount }: BarrioShowProps) {
  const [mapMounted, setMapMounted] = useState(false);
  useEffect(() => setMapMounted(true), []);

  return (
    <MainLayout>
      <Head>
        <title>{`Frutas y Verduras Frescas en ${barrio.name} | Abasto Virtual`}</title>
        <meta
          name="description"
          content={`Delivery de frutas y verduras frescas en ${barrio.name}, ${barrio.city}. Selección diaria del Mercado de Abasto con entrega programada.`}
        />
        <link rel="canonical" href={`${appUrl}/barrios-privados/${barrio.slug}`} />
      </Head>

      <BarrioHero barrio={barrio} whatsappUrl={whatsappUrl} discount={discount} />

      {stats && (
        <BarrioStats barrio={barrio} stats={stats} dynamicPhrases={dynamicPhrases} />
      )}

      <BarrioDelivery barrio={barrio} delivery={delivery} whatsappUrl={whatsappUrl} />

      {mapMounted ? (
        <React.Suspense fallback={<div style={{ height: 400, background: '#fafaf7' }} />}>
          <LazyBarrioMap lat={barrio.lat} lon={barrio.lon} name={barrio.name} />
        </React.Suspense>
      ) : (
        <div style={{ height: 400, background: '#fafaf7' }} />
      )}

      <WhyFresh />
      <TrustedDelivery />
      <BarriosProducts products={featuredProducts} />
      <BarrioNearby nearby={nearby} />
      <FinalCTA loginUrl="" whatsappUrl={whatsappUrl} />
      <BarrioSEO barrio={barrio} appUrl={appUrl} />
    </MainLayout>
  );
}
